import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import {Tooltip, Typography} from "antd";
import clsx from "clsx";

import suspended from "../../../assets/icons/suspended.svg";
import devices_wdc from "../../../assets/icons/devices_wdc.svg";
import device_ie_node from "../../../assets/icons/device_ie_node.svg";
import device_f_500 from "../../../assets/icons/devices_f_500.svg";
import devices_wdc_suspended from "../../../assets/icons/devices_wdc_suspended.svg";
import device_ie_node_suspended from "../../../assets/icons/device_ie_node_suspended.svg";
import device_f_500_suspended from "../../../assets/icons/devices_f_500_suspended.svg";

import success from "../../../assets/icons/succsess_green.svg";
import notify from "../../../assets/icons/red_notify.svg";
import active from "../../../assets/icons/active.svg";
import warning from "../../../assets/icons/warning_icon_big.svg";
import offline from "../../../assets/icons/offline.svg";

import {ReactComponent as Edit} from "../../../assets/icons/device_edit.svg";

import {devicesAC} from "../../../store/branches/devices/actionCreators";
import {Device} from "../../../store/branches/devices/stateTypes";
import {usePermissions} from "../../../hooks/usePermissions";
import {selectUserState} from "../../../store/selectors";

import classes from "../Devices.module.scss";

const {Title} = Typography;

const DevicesBlock: React.FC<Device> = ({
                                            id,
                                            title,
                                            is_suspended,
                                            is_online,
                                            selectedDevice,
                                            device_type,
                                        }) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const {isOEM, isSuperUser, hasAccessToEdit} = usePermissions();
    const {hasAlarm, hasWarning} = useSelector(selectUserState);

    const isAlarmDevice = hasAlarm.some(item => item.device.id === id);
    const isWarningDevice = hasWarning.some(item => item.device.id === id);

    const DEVICE_TYPE_IMAGES = {
        "F500": device_f_500,
        "0300": devices_wdc,
        "0005": device_ie_node,
        "0006": device_ie_node,
        "F500-UDF": device_f_500,
        "0007":  device_ie_node,
         "00TX":  device_ie_node,
         "0008":  device_ie_node,
         "001W": device_ie_node 
    };

    const DEVICE_TYPE_IMAGES_SUSPENDED = {
        "F500": device_f_500_suspended,
        "0300": devices_wdc_suspended,
        "0005": device_ie_node_suspended,
        "0006": device_ie_node_suspended,
        "F500-UDF": device_f_500_suspended,
        "0007": device_ie_node_suspended,
        "0008": device_ie_node_suspended,
        "00TX": device_ie_node_suspended,
        "001W": device_ie_node_suspended,
    };

    const onEdit = (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
        event.preventDefault();
        event.stopPropagation();
        history.push(`/devices/edit/device/${id}`);
        dispatch(devicesAC.fetchCurrentDevice(id));
    };

    const handleSelect = (event: React.MouseEvent<HTMLDivElement>) => {
        event.preventDefault();
        if (is_suspended) {
            if (isOEM || isSuperUser) {
                dispatch(devicesAC.selectDevice(id.toString()));
                return;
            }
            return;
        }
        dispatch(devicesAC.selectDevice(id.toString()));
    };

    return (
        <div className={clsx({
            [classes.devicesBlockWrap]: true,
            [classes.suspendedBlockWrap]: is_suspended,
            [classes.OEMCursor]: isOEM || isSuperUser,
            [classes.selectedDevice]: (id === selectedDevice),
        }, isAlarmDevice ? classes.hasAlarmedSensor :
            isWarningDevice ? classes.hasWarningSensor : "")}

             onClick={(event) => handleSelect(event)}
        >

            <div className={classes.pic}>
                <img src={is_suspended ? DEVICE_TYPE_IMAGES_SUSPENDED[device_type] : DEVICE_TYPE_IMAGES[device_type]}
                     alt="powerHold"
                     className={classes.devicesPic}/>
                {
                    isAlarmDevice
                        ?
                        <img src={notify} alt="" className={classes.notify}/>
                        :
                        isWarningDevice
                            ?
                            <img src={warning} alt="" className={classes.notify}/>
                            :
                            is_online && <img src={success} alt="" className={classes.notify}/>
                }
            </div>

            <div className={classes.activation}>
                <img src={is_online ? active : is_suspended ? suspended : offline} alt="activation"/>
                <span className={clsx(
                    is_online ? classes.active : is_suspended ? classes.suspended : classes.offline)}>

                    {is_online ? "Active" : is_suspended ? "Suspended" : "Offline"}

                </span>
                <Title level={4}>
                    <div className={classes.titleContainer}>
                        <Tooltip placement="topLeft" title={title}>
                            <span className={classes.title}>{title}</span>
                        </Tooltip>
                    </div>
                </Title>
            </div>

            <div className={classes.editButton}>
                {
                    hasAccessToEdit &&
                    <div className={classes.editButtonIcon}>
                        <Tooltip placement="topRight" title="Edit device">
                            <Edit onClick={(event) => onEdit(event)}/>
                        </Tooltip>
                    </div>
                }
            </div>
            {
                (id === selectedDevice)
                &&
                <div className={classes.flagIcon}/>
            }
        </div>
    );
};

export default DevicesBlock;
